import type { ReactElement } from 'react'
import type { Step } from '../state/types.js'
import { IntroScreen } from './IntroScreen.js'
import { EmailScreen } from './EmailScreen.js'
import { LandingScreen } from './LandingScreen.js'
import { ApplianceStatusScreen } from './ApplianceStatusScreen.js'
import { ScanModelLabelScreen } from './ScanModelLabelScreen.js'
import { ModelLookupScreen } from './ModelLookupScreen.js'
import { ScanCountertopScreen } from './ScanCountertopScreen.js'
import { CountertopResultsScreen } from './CountertopResultsScreen.js'
import { ScanUndersinkScreen } from './ScanUndersinkScreen.js'
import { UndersinkResultsScreen } from './UndersinkResultsScreen.js'
import { QAScreen } from './QAScreen.js'
import { ReviewScreen } from './ReviewScreen.js'
import { ScheduleScreen } from './ScheduleScreen.js'
import { ConfirmationScreen } from './ConfirmationScreen.js'

export const SCREENS: Record<Step, () => ReactElement> = {
  'intro':                 IntroScreen,
  'email':                 EmailScreen,
  'landing':               LandingScreen,
  'appliance-status':      ApplianceStatusScreen,
  'scan-model-label':      ScanModelLabelScreen,
  'model-lookup':          ModelLookupScreen,
  'scan-countertop':       ScanCountertopScreen,
  'countertop-results':    CountertopResultsScreen,
  'scan-undersink':        ScanUndersinkScreen,
  'undersink-results':     UndersinkResultsScreen,
  'qa':                    QAScreen,
  'review':                ReviewScreen,
  'schedule':              ScheduleScreen,
  'confirmation':          ConfirmationScreen,
}
